export default __webpack_public_path__ + "static/media/banner-arrL.9ed323bb.png";